export const targetTypeOptions = [
  { value: '', label: 'انتخاب نوع هدف' },
  { value: 'device', label: 'دستگاه' },
  { value: 'gateway', label: 'گیت‌وی' },
  { value: 'tag', label: 'تگ ـ گروه دستگاه‌ها' },
];

export const severityOptions = [
  { value: '', label: 'انتخاب سطح اهمیت' },
  { value: 'info', label: 'اطلاعاتی' },
  { value: 'warning', label: 'هشدار' },
  { value: 'critical', label: 'بحرانی' },
];

export const ruleTypeOptions = [
  { value: '', label: 'انتخاب نوع قانون' },
  {
    value: 'threshold',
    label: 'آستانه (Threshold)',
  },
  {
    value: 'timewindow',
    label: 'بازه زمانی (Time Window)',
  },
  {
    value: 'lifecycle',
    label: 'عدم دریافت داده',
  },
  {
    value: 'roc',
    label: 'نرخ تغییر (ROC)',
    disabled: true,
  },
];

export const operatorOptions = [
  { value: '', label: 'انتخاب عملگر' },
  { value: '>', label: 'بزرگتر از (>)' },
  { value: '<', label: 'کوچکتر از (<)' },
  { value: '==', label: 'مساوی (==)' },
  { value: '>=', label: 'بزرگتر مساوی (>=)' },
  { value: '<=', label: 'کوچکتر مساوی (<=)' },
  { value: '!=', label: 'نامساوی (!=)' },
  { value: 'between', label: 'مابین (between)' },
  {
    value: 'not_between',
    label: 'مابین نباشد (not between)',
  },
];

export const statusOptions = [
  { value: true, label: 'فعال' },
  { value: false, label: 'غیرفعال' },
];

export const operatorReadableMap = {
  '>': 'بزرگتر از',
  '<': 'کوچکتر از',
  '==': 'برابر با',
  '>=': 'بزرگتر یا مساوی',
  '<=': 'کوچکتر یا مساوی',
  '!=': 'نامساوی با',
  between: 'بین',
  not_between: 'خارج از بازه',
};
